import { VelocityWalletName } from 'src/constants/wallets';
import { WalletToDisplayInfo } from 'src/hooks/useWalletsToDisplay';
import { MoreWalletsCta } from '../../../ConnectWalletButtonsList';
import { WalletButton } from 'src/components/ConnectWalletButtonsList/WalletButton';
import useFeatureFlagStore from 'src/stores/featureFlag/useFeatureFlagStore';
import VelocityTextLogo from 'src/components/Icons/VelocityTextLogo';
import PrivyEmailInput from 'src/components/Modals/Onboarding/ConnectWalletModal/ConnectWalletModalPrivyOptions/PrivyEmailInput';
import Divider from 'src/components/primitives/Divider/Divider';
import PrivyGoogleOAuthButton from 'src/components/Modals/Onboarding/ConnectWalletModal/ConnectWalletModalPrivyOptions/PrivyGoogleOAuthButton';

export const MainWalletsPage = (props: {
	wallets: WalletToDisplayInfo[];
	hiddenWallets: WalletToDisplayInfo[];
	onChooseWallet: (walletName: VelocityWalletName) => void;
	onShowMoreWallets: () => void;
	onLoginWithPrivyEmail: () => void;
	privyEmail: string;
	setPrivyEmail: (email: string) => void;
	privyOtpResendSecondsRemaining: number;
}) => {
	const isPrivyNativeAccountsEnabled = useFeatureFlagStore((s) =>
		s.flagEnabled('ENABLE_PRIVY_NATIVE_ACCOUNTS')
	);

	return (
		<div className="flex flex-col gap-y-xl pt-2xl pb-xs not-sm:h-full">
			<VelocityTextLogo className="w-25 self-center" />

			{isPrivyNativeAccountsEnabled && (
				<>
					<PrivyEmailInput
						email={props.privyEmail}
						setEmail={props.setPrivyEmail}
						onLoginWithPrivyEmail={props.onLoginWithPrivyEmail}
						otpResendSecondsRemaining={props.privyOtpResendSecondsRemaining}
					/>

					<div className="flex items-center gap-x-sm">
						<Divider />
						<span className="typo-body-sm whitespace-pre text-text-secondary">
							or continue with
						</span>
						<Divider />
					</div>
				</>
			)}

			<div className="flex flex-col gap-y-md">
				{isPrivyNativeAccountsEnabled && <PrivyGoogleOAuthButton />}

				{props.wallets.map((walletProvider) => (
					<WalletButton
						onChooseWallet={() => {
							if (walletProvider.action) {
								walletProvider.action();
								return;
							}

							props.onChooseWallet?.(walletProvider.provider.adapter.name);
						}}
						wallet={walletProvider}
						key={walletProvider.provider.adapter.name}
					/>
				))}
			</div>

			<Divider />

			<MoreWalletsCta
				onClick={props.onShowMoreWallets}
				wallets={props.hiddenWallets}
			/>
		</div>
	);
};
